import React from 'react';
import classNames from 'classnames';
import IPfTileImage from './pfTileImage.d';
import styles from './pfTileImage.scss';

function PfTileImage(props: IPfTileImage) {
    const { image, on_hover, showAvailableSizes, 
        articleName, colorName, mainViewMlt } = props;

    function getAltTagValue(): string {
        const tmpColorName = colorName ? ', ' + colorName : '';
        return mainViewMlt + ', ' + articleName + tmpColorName;
    }

    return (
        <div className={classNames(styles.t_img_container, styles.pf_result,
            {
                [styles.on_hover]: on_hover,
            })}>
            <img className={classNames(styles.t_img, { [styles.t_shrink_img]: showAvailableSizes })}
                src={image} 
                loading='lazy' 
                alt={getAltTagValue()}/>
        </div>
    );
}

export default PfTileImage;
